import { render } from "./SalesManagementView.vue?vue&type=template&id=913ac198"
import script from "./SalesManagementView.vue?vue&type=script&lang=js"
export * from "./SalesManagementView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__